import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { FcmToken, FcmTokenAddRequest } from '@shared/user/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({ providedIn: 'root' })
export class FcmTokenApiService {
  private readonly basePath = '/v.1/fcm-token';
  private readonly publicPath = '/fcm-token';

  constructor(private readonly http: ApiClientService) {}

  setFcmToken(data: FcmTokenAddRequest): Observable<FcmToken> {
    return this.http.post<FcmToken>(`${this.basePath}`, data);
  }

  // todo repalce with deleting the token
  deleteFcmTokenForDeviceId(deviceId: string): Observable<void> {
    return this.http.delete(`${this.publicPath}/${deviceId}`);
  }
}
